

const cards = [
  {
    icon: "🗺️",
    title: "Plan a Wine Tour",
    description: "Discover optimal wine routes across Europe. Let AI build your perfect multi-day itinerary.",
    action: "Start planning",
    path: "/plan",
    color: "#3D4A1A",
  },
  {
    icon: "🍷",
    title: "Winery Manager",
    description: "Manage your winery profile, availability slots and incoming booking requests.",
    action: "Manage winery",
    path: "/manage",
    color: "#8B1A2F",
  },
  {
    icon: "🛤️",
    title: "Wine Road Representative",
    description: "Review and verify winery information on your assigned wine road.",
    action: "Review wineries",
    path: "/road-rep",
    color: "#886070",
  },
  {
    icon: "⚙️",
    title: "Platform Admin",
    description: "Manage wine roads, users, and platform settings.",
    action: "Admin panel",
    path: "/admin",
    color: "#4A5E38",

  },
];

export default function LandingPage() {
  const navigate = (path) => { window.location.href = path; };

  return (
    <div style={{ minHeight: "100vh", background: "#F2F5EC" }}>
      {/* Header */}
      <header style={{ background: "rgba(242,245,236,0.96)", backdropFilter: "blur(10px)", borderBottom: "1px solid #C4D0A8", padding: "0 24px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 40 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 22 }}>🍷</span>
          <span style={{ fontFamily: "'Playfair Display',serif", fontSize: 18, fontWeight: 600, color: "#1E2C14" }}>Wine Route Manager</span>
        </div>
        <div style={{ fontSize: 11, color: "#6A7E58" }}>European Wine Tourism Platform</div>
      </header>

      {/* Hero */}
      <div style={{ textAlign: "center", padding: "60px 24px 40px" }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#886070", textTransform: "uppercase", letterSpacing: "0.15em", marginBottom: 12 }}>Welcome</div>
        <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 36, fontWeight: 700, color: "#1E2C14", margin: "0 0 16px", lineHeight: 1.2 }}>
          Your European Wine Journey<br />Starts Here
        </h1>
        <p style={{ fontSize: 15, color: "#5A6E48", maxWidth: 480, margin: "0 auto", lineHeight: 1.6 }}>
          AI-powered wine tour planning across Vienna–Venice, Ahr Valley and Małopolska wine roads.
        </p>
      </div>

      {/* Cards */}
      <div style={{ maxWidth: 900, margin: "0 auto", padding: "0 24px 60px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16 }}>
        {cards.map(card => (
          <div key={card.path}
            onClick={() => !card.disabled && navigate(card.path)}
            style={{
              background: "white", borderRadius: 14, padding: 28,
              border: "1px solid #C4D0A8",
              cursor: card.disabled ? "default" : "pointer",
              opacity: card.disabled ? 0.5 : 1,
              transition: "transform 0.15s, box-shadow 0.15s",
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            }}
            onMouseEnter={e => { if (!card.disabled) { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.1)"; }}}
            onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)"; }}
          >
            <div style={{ fontSize: 36, marginBottom: 16 }}>{card.icon}</div>
            <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 18, fontWeight: 600, color: "#1E2C14", margin: "0 0 10px" }}>{card.title}</h2>
            <p style={{ fontSize: 13, color: "#5A6E48", lineHeight: 1.6, margin: "0 0 20px" }}>{card.description}</p>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, color: card.color }}>
              {card.disabled ? "Coming soon" : card.action} {!card.disabled && "→"}
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <footer style={{ borderTop: "1px solid #C4D0A8", padding: "20px 24px", textAlign: "center" }}>
        <div style={{ fontSize: 11, color: "#8A9E78" }}>Wine Route Manager · Prototype · eu-central-1</div>
      </footer>
    </div>
  );
}
